import Promise from 'bluebird'
import _ from 'lodash'
import * as types from './action-types'

const alabamaFips = 1;
const countyFip = 1001;
const yearDefault = 2015;
const xDefault = 'TC3';
const yDefault = 'RaEV1';

export const selectField = (field, dimension) => {
  return {
    type: types.SELECT_FIELD,
    field: field,
    dimension: dimension || 'x'
  };
};

export const selectYear = (year) => {
  return {
    type: types.SELECT_YEAR,
    year
  };
};

export const selectPage = (page) => {
  return (dispatch) => {
    dispatch({type: types.PAGE_TRANSITION_START});
    dispatch({type: types.SELECT_PAGE, page});

    Promise.delay(400)
      .then(() => dispatch({type: types.PAGE_TRANSITION_END}))
  };
};

export const selectState = (stateFips, countyFips) => {
  return (dispatch, getState, api) => {
    dispatch({type: types.SELECT_STATE, stateFips});
    dispatch(getStateData(stateFips, countyFips));
  };
};

export const selectCounty = countyFips => {
  return (dispatch, getState, api) => {
    dispatch({type: types.SELECT_COUNTY, countyFips});
  };
};

export const getNationalData = () => {
  return (dispatch, getState, api) => {
    dispatch({type: types.GET_NATIONAL_AVG_DATA});

    return api.getUsaAveragesData()
      .then(data => dispatch({type: types.NATIONAL_AVG_DATA_RECEIVED, data}))
      .then(() => dispatch({type: types.GET_NATIONAL_DATA}))
      .then(() => api.getNationalData())
      .then(data => dispatch({type: types.NATIONAL_DATA_RECEIVED, data}))
      .then(() => Promise.delay(800))
      .then(() => dispatch({type: types.GET_NATIONAL_PCT_DATA}))
      .then(() => api.getNationalPercentileData())
      .then(data => dispatch({type: types.NATIONAL_PCT_DATA_RECEIVED, data}))
  }
};

export const getStateData = (stateFips, countyFips) => {
  return (dispatch, getState, api) => {
    dispatch({type: types.GET_STATE_DATA});

    return api.getStateData(stateFips)
      .then(data => {
        countyFips = countyFips || _.get(data, [0, 'cf']);
        dispatch({type: types.STATE_DATA_RECEIVED, data});
        return dispatch(selectCounty(countyFips));
      })
      .then(() => Promise.delay(1000))
      .then(() => dispatch({type: types.GET_STATE_PCT_DATA}))
      .then(() => api.getStatePercentileData(stateFips))
      .then(data => dispatch({type: types.STATE_PCT_DATA_RECEIVED, data}))
  }
};

export const getDimensionData = () => {
  return (dispatch, getState, api) => {
    dispatch({type: types.GET_DIMENSION_DATA});

    return api.getDimensionsData()
      .then(data => {
        dispatch({type: types.DIMENSION_DATA_RECEIVED, data});
      });
  }
};

export const getSearchData = () => {
  return (dispatch, getState, api) => {
    dispatch({type: types.GET_SEARCH_DATA});

    return api.getSearchData()
      .then(data => {
        dispatch({type: types.SEARCH_DATA_RECEIVED, data});
      });
  }
};

export const reset = () => {
  return dispatch => {
    dispatch(selectField(xDefault, 'x'));
    dispatch(selectField(yDefault, 'y'));
    dispatch(selectYear(yearDefault));
  }
};

export const initialize = () => {
  return dispatch => {

    return dispatch(getDimensionData())
      .then(() => dispatch(selectField(xDefault, 'x')))
      .then(() => dispatch(selectField(yDefault, 'y')))
      .then(() => dispatch(getNationalData()))
      .then(() => dispatch(selectState(alabamaFips, countyFip)))
      .then(() => dispatch(getSearchData()));
  }
};


// WEBPACK FOOTER //
// ./src/redux/actions/index.js